import _ from 'lodash';

export const randomIndex = ceil => Math.floor(Math.random() * ceil);

export const randomItem = array => array[randomIndex(array.length)];

export const randomWeightedIndex = (array, { weightKey = 'weight' } = {}) => {
  const weightsSum = _.sumBy(array, arrayItem => (arrayItem[weightKey] || 1));
  const probabilityUnit = 1 / weightsSum;

  let sum = 0; // CDF
  const cumulativeSums = array.map((arrayItem) => {
    sum += (arrayItem[weightKey] || 1) * probabilityUnit;
    return sum;
  });
  const randomNumber = Math.random();
  return cumulativeSums.findIndex(sumsItem => (sumsItem >= randomNumber));
};

export const randomInterval = () => Math.floor(((Math.random() * 6) + 3) * 1000);

export const randomId = () => Math.random().toString(36).substr(2, 9);

export default {
  index: randomIndex,
  weightedIndex: randomWeightedIndex,
  item: randomItem,
  interval: randomInterval,
  id: randomId,
};
